export default __webpack_public_path__ + "static/media/flag_off.abdd7537.svg";